export const AUTH_PROJECT_NAME = 'hazard_mitigation';

// export const AUTH_HOST = 'http://localhost:3457';
export const AUTH_HOST = 'https://availauth.availabs.org';
